module.exports = __webpack_public_path__ + "img/packages/l2.08207a.png";